export const navLinks = [
  { href: '#technologia', label: 'Technológia' },
  { href: '#pwa', label: 'PWA' },
  { href: '#portfolio', label: 'Portfólio' },
  { href: '#interior-ai', label: 'Interior AI' },
  { href: '#kontakt', label: 'Kontakt' },
]

export const cloudLink = {
  href: 'https://cloud-sparkle-nexus.lovable.app',
  label: 'Cloud NS/AI',
}

export const privacyUrl = 'https://gruppa.cloud/privacy/'
export const interiorDemoUrl = 'https://interiorai.nexify-studio.tech'
export const contactEmail = 'hello@nexify-studio.tech'
